import React, { useState, useEffect } from 'react';
import { ThemeProvider } from "@material-ui/core"
import TextField from '@material-ui/core/TextField';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormDatePicker from '../../../components/DatePicker';
import { useSelector, useDispatch } from "react-redux";

//import DataTable from './DataTable';
//import PlannedIdleTime from './PlannedIdleTime';
//import UnplannedIdleTime from './UnplannedIdleTime';
//import IHFTime from './IHFTime';
import { lightTheme } from "../../../SharedComponents/SharedComponentStyles";
import axios from 'axios';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';
//Autocomplete
import Autocomplete from '@material-ui/lab/Autocomplete';
import MaterialTable from "material-table";
//import { tableOptionsUser } from "../../SharedComponents/SharedComponentStyles";
import { forwardRef } from "react";
//import Autocomplete from '@mui/material/Autocomplete';

//import TextArea from '@material-ui/core/TextareaAutosize';

import {
    AddBox,
    Check,
    DeleteOutline,
    Edit,
    SaveAlt,
    FilterList,
    FirstPage,
    LastPage,
    ChevronRight,
    ChevronLeft,
    Clear,
    Search,
    ArrowDownward,
    Remove,
    ViewColumn,
    CenterFocusStrong,
} from "@material-ui/icons";




const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};
var columns = [
    { title: "Material Number", field: "material" },
    { title: "Location", field: "location" },
    
  
    { title: "System Inventory(QTY)", field: "systemInvventoryQty" },
    
    { title: "System Inventory(INR)", field: "systemInvventoryINR" },

]

var columns1 = [
    { title: "Material Number", field: "materialName" },
    { title: "Location", field: "locationName" },


    { title: "Physical Inventory(QTY)", field: "countedPhyQuantity" },

    { title: "Slip number", field: "slipnumber" },

    { title: "Slip Created by", field: "slipCreatedBy" },

]
const data = [
    {
        mrp: "ABCDEF",
        id: "12345678",
        sys: "100",
        phy: "30",
        net: "40",
        pos: "60",
        neg: "50",
        gross: "90",
        net: "45",
        gdiff: "80"

    }
];
export default function TableEdit() {
    const [SAPMaterial, setphyInvSAPMaterial] = useState([]);
    const [SlipMaterial, setphyInvSlipMaterial] = useState([]);
    const [openLoader, setopenLoader] = useState(false);
    const token = useSelector((state) => state.saveAzureTokenReducer.token);
    const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData);
    const bearerToken = useSelector(
    (state) => state.saveBearerTokenReducer.bearerToken);
    const uId = useSelector((state) => state.saveUIDReducer.uid);

    const api = axios.create({
        baseURL: 'InventoryReport'
    })
    useEffect(() => {
        var materialNumber = ''; var plantName = '';
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");            
            if (pair[0] == 'MaterialNumber') {
                 materialNumber = window.atob(pair[1]);
            }
            if (pair[0] == 'PlantName') {
                plantName = window.atob(pair[1]);
            }
        }
        //var materialNumber = window.atob(getURLParameter("MaterialNumber"));
        //var plantName = window.atob(getURLParameter("PlantName"));
       // console.log("materialNumber", materialNumber);
       // console.log("plantName", plantName);
        BindSAPDetails(materialNumber, plantName);
        BindSlipDetails(materialNumber, plantName);
        //console.log("materialNumber", materialNumber);
      
    }, []);
    async function BindSAPDetails(materialNumber, plantName) {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        setopenLoader(true);
        let PhyInvInputData = {
            MaterialName: materialNumber,
            PlantName: plantName
        }

        api.post('/GetSAPMaterialList/', PhyInvInputData,{headers: headers})
            .then(res => {
                setphyInvSAPMaterial(res.data);
              //  console.log("MaterialSAPDetails", res.data);
                setopenLoader(false);


            })
            .catch(error => {
                console.log("Error in hitting api at page load. PhyInvLocation");
                setopenLoader(false);

            })
    }

    async function BindSlipDetails(materialNumber, plantName) {
        setopenLoader(true);
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        let PhyInvInputData = {
            MaterialName: materialNumber,
            PlantName: plantName
        }

        api.post('/GetSlipMaterialList/', PhyInvInputData,{headers: headers})
            .then(res => {
                setphyInvSlipMaterial(res.data);
               // console.log("MaterialSlipDetails", res.data);
                setopenLoader(false);


            })
            .catch(error => {
                console.log("Error in hitting api at page load. PhyInvLocation");
                setopenLoader(false);

            })
    }


    function getURLParameter(sParam) {
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split('=');
            var value = getParamName(sParameterName, sParam);
            return value;
        }
    }
    function getParamName(sParameterName, sParam) {
    var value = '';
    for (var j = 0; j < sParameterName.length; j++) {
        if (sParameterName[j] == sParam) {
            value = value + getParanValue(j, sParameterName);
            break;
        }
        else {
            continue;
        }
    }
    return value;
    }
    function getParanValue(j, sParameterName) {
        var value = '';
        for (var k = j + 1; k < sParameterName.length; k++) {
            value = value + sParameterName[k];
        }
        return value;
    }
    return (
        <ThemeProvider theme={lightTheme}>
            <div className="master-layout-data">
                <Box paddingTop={{ xs: '5rem', sm: '2rem' }} className="">
                    <h3 className="clr-dark-blue d-flex jc-center mt-2 mb-1"></h3>
                </Box>
                <Grid container spacing={2} className="d-flex mt-1 fd-row mb-1 px-1 box-shadow width-100 bdr-radius ">

                    <Grid item xs={12} >
                       <h4>SAP/System Inventory</h4>
                        <MaterialTable
                            //title="SAP/System Inventory"
                            columns={columns}
                            data={SAPMaterial}
                            //align={CenterFocusStrong}
                            icons={tableIcons}
                            //options={tableOptions}
                            options={{
                                showTitle: false,
                                pageSizeOptions: [30, 40, 50],    // rows selection options
                                pageSize: 5,
                                maxBodyHeight: 600,                                
                                search: false,
                            }}

                        />
                    </Grid>
                    <Grid item xs={12} >   
                        <h4>Slip Entries</h4>
                        <MaterialTable       
                            // title="Slip Entries"                            
                            columns={columns1}
                            data={SlipMaterial}
                            //align={CenterFocusStrong}
                            icons={tableIcons}
                            //options={tableOptions}
                            options={{
                                showTitle: false,
                                pageSizeOptions: [30, 40, 50],    // rows selection options
                                pageSize: 5,
                                maxBodyHeight: 600,
                                search: false,
                            }}

                        />
                    </Grid>
                </Grid>
                <Dialog
                    open={openLoader}
                    //onClose={handleClose}
                    aria-labelledby="draggable-dialog-title"
                    id="templateUploadSuccess"
                    PaperProps={{
                        style: {
                            backgroundColor: "transparent",
                            boxShadow: "none",
                            borderColor: "transparent"
                        },
                    }}>
                    <DialogContent>
                        <CircularProgress />
                    </DialogContent>
                </Dialog>

            </div>
        </ThemeProvider>

        
        );
        

}